import { render, staticRenderFns } from "./nodata.vue?vue&type=template&id=2f0cb284&scoped=true&"
import script from "./nodata.vue?vue&type=script&lang=js&"
export * from "./nodata.vue?vue&type=script&lang=js&"
import style0 from "./nodata.vue?vue&type=style&index=0&id=2f0cb284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0cb284",
  null
  
)

export default component.exports